export enum QueryKey {
  REDIRECT_ID = 'redirectId',
}
